/**
 *
 * CardDocumentItem
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { COLORS } from 'theme';

import { IconContainer, Item, Actions, Content } from './CardData.styles';

const CardDocumentItem = ({ preview, download, featured, icon, title }) => (
  <Item disablePadding type="document">
    {icon && <IconContainer type="document">{icon}</IconContainer>}
    {title && <Content>{title}</Content>}
    <Actions>
      {preview}
      {featured && (
        <IconContainer color={COLORS.kinetikBlue}>{featured}</IconContainer>
      )}
      {download}
    </Actions>
  </Item>
);

CardDocumentItem.propTypes = {
  preview: PropTypes.node,
  download: PropTypes.node,
  icon: PropTypes.node,
  featured: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default memo(CardDocumentItem);
